export default "__VITE_ASSET__2db11873__"